import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { PayrollGroupService } from './payroll-group.service';
import { PayrollGroupModel } from './model/payroll-group.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-payroll-group',
  standalone: false,
  templateUrl: './payroll-group.component.html',
  styleUrl: './payroll-group.component.scss'
})
export class PayrollGroupComponent {
  payrollList: PayrollGroupModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;

  filter: FilterListItemModel[] = [
    { title: "Code", column: "code" },
    { title: "Name", column: "name" },
    { title: "Description", column: "description" },
  ];
  displayedColumns = ['code', 'name', 'description', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  };

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: PayrollGroupModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<PayrollGroupModel>(true, []);
  dataSource = new MatTableDataSource(this.payrollList);
  permission: any;


  constructor(
    private breakpointObserver: BreakpointObserver,
    private PayrollGroupService: PayrollGroupService,
    private stateManagerService: StateManagerService,
    public dialog: MatDialog,
    private permissionService: PermissionService,
    private snackBarService: SnackBarService,
    private router: Router
  ) {
    this.payrollList = [];
    this.permission = this.permissionService.getPagePermission('payroll-group');
    console.log(this.permission);
  }

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
    });
  }

  ngAfterViewInit(): void {
    this.loadPreviousState();
  }

  setDataSource(payrollGroups: PayrollGroupModel[]): void {
    this.payrollList = payrollGroups;
    this.dataSource = new MatTableDataSource(payrollGroups);
    this.dataSource.sort = this.sort;
  }

  loadPreviousState(): void {
    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {
      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('name', 'asc');
      this.loadData();
    }
  }

  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.payrollList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.payrollList);
  }

  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };
    return requestData;
  }

  /**
   * Check and apply default filter for is_system = 0.
   **/
  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "is_system")
    ) {
      defFilter.push({
        column: "is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();
  }

  onDelete(payrollInfo: PayrollGroupModel): void {
    const message = `Are you sure, you want to delete ${payrollInfo.name}?`;
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.PayrollGroupService.delete(payrollInfo).subscribe({
          next: (response: { status: string; message: any; }) => {
            if (response.status == 'SUCCESS') {
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + payrollInfo.name + " has been deleted successfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: () => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.PayrollGroupService.getList(requestData).subscribe((response: { status: string; data: { payroll_groups: PayrollGroupModel[]; total_count: number; }; message: any; }) => {
      if (response.status == 'SUCCESS') {
        this.setDataSource(response.data.payroll_groups);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.payrollList[0]);
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  }

  onRowSelected(payrollInfo: PayrollGroupModel): void {
    this.selectedItem = payrollInfo;
    this.showSummaryPanel = true;
  }

  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }

  getSearchParam(): SearchParam {
    return this.searchColumFilter;
  }

  onEdit(payrollInfo: PayrollGroupModel): void {
    this.router.navigate(['payroll/payroll-group-edit', payrollInfo.id]);
  }

  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;
    this.loadData();
  }

  addClicked(): void {
    this.router.navigate(['payroll/payroll-group-edit', 0]);
  }

  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.PayrollGroupService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'payrollgroup.csv';
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;
        },
        error: error => {
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
        }
      });
  }
}


